import { useContext, useRef, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Toast } from "primereact/toast";

import { UserPermissionContext } from "../../context/UserPermissionProvider";
import { DisplayErrors } from "../../Utils/ErrorHandler";

import RCTLogo from "../../images/RCTLogo.png";

import styles from "../Authorization/Authorization.module.css";

const Authorization = ({ onLoginProcess }) => {
    const toast = useRef(null);
    const { loadPermissions } = useContext(UserPermissionContext);

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const LoginUserHandler = async (e) => {
        e.preventDefault();

        if (!username || !password) {
            toast.current.show({
                severity: "warn",
                summary: "Помилка",
                detail: "Введіть логін та пароль",
                life: 3000
            });
            return;
        }

        try {
            setLoading(true);

            const response = await fetch(
                process.env.REACT_APP_BACKEND_URL + "auth/token/",
                {
                    method: "POST",
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json",
                        "X-APP-ID": "ADMIN_PANEL"
                    },
                    body: JSON.stringify({ username, password })
                }
            );

            if (response.status !== 200) {
                throw new Error("Неправильний логін або пароль");
            }

            const content = await response.json();
            const decoded = jwtDecode(content.access);

            // Fetch user metadata
            const metaResponse = await fetch(
                process.env.REACT_APP_BACKEND_URL + "auth/get_user_methadata/",
                {
                    headers: {
                        "Authorization": `Bearer ${content.access}`
                    }
                }
            );

            if (metaResponse.status === 200) {
                const meta = await metaResponse.json();
                Cookies.set("isDarkTheme", meta.theme === "DARK");
            } else {
                DisplayErrors(metaResponse, toast);
            }

            Cookies.set("organization", decoded.organization);
            Cookies.set("division", decoded.division_id);
            Cookies.set("userId", decoded.user_id);

            if (content.logo) {
                Cookies.set("avatar", content.logo);
            }

            await loadPermissions(decoded.user_id);

            onLoginProcess({
                userName: decoded.username,
                accessToken: content.access,
                refreshToken: content.refresh,
                avatar: decoded.logo
            });
        } catch (err) {
            toast.current.show({
                severity: "error",
                summary: "Помилка входу",
                detail: err.message,
                life: 3000
            });
        } finally {
            setLoading(false);
            setPassword("");
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <div className={styles.authPage}>
            <div className="flex align-items-center justify-content-center min-h-screen p-3">
                <Card className="w-full sm:w-25rem shadow-4" style={{ backgroundColor: "#3a3a3aa2"}}>
                    <div className="flex flex-column align-items-center gap-3">
                        <img src={RCTLogo} alt="RCT Logo" width={120} />

                        <h2 className="m-0 text-300">RCT CRM</h2>
                        <small className="text-300">
                            Вхід в систему
                        </small>

                        <form
                            onSubmit={LoginUserHandler}
                            className="flex flex-column gap-4 w-full mt-3"
                        >
                            <FloatLabel>
                                <InputText
                                    id="username"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="w-full"
                                    autoFocus
                                />
                                <label htmlFor="username">Логін</label>
                            </FloatLabel>

                            <FloatLabel>
                                <Password
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    toggleMask
                                    feedback={false}
                                    className="w-full"
                                    pt={{
                                        iconField: {
                                            root: {
                                                style: { width: "100%" },
                                            },
                                        },
                                        input: {
                                            style: { width: "100%" },
                                        },
                                        root: {
                                            style: { width: "100%" },
                                        },
                                    }}
                                />
                                <label htmlFor="password">Пароль</label>
                            </FloatLabel>

                            <Button
                                type="submit"
                                label="Увійти"
                                icon="pi pi-sign-in"
                                loading={loading}
                                severity="warning"
                                className={`text-100 w-full`}
                            />
                        </form>
                        <small className="text-300 mt-4">
                            © 2024–2026 Red Cat Tech · v1.24.1
                        </small>
                    </div>
                </Card>
            </div>
            </div>
        </>
    );
};

export default Authorization;